<template>
  <div>
    <a-modal modal-id="add-credentials">
      <div slot="title">Account Credentials</div>
      <div slot="form">
        <div v-if="isDecrypted">
          <div class="row m-t-sm">
            <div v-for="(cred, i) in Object.entries(credentials)" :key="account.name + '-edit-' + i"
                 class="col-lg-12">
              <div class="row m-t-xs" v-if="cred[0] !== 'otp'">
                <div class="col-lg-3">
                  <strong>{{ cred[0] }}</strong>
                </div>
                <div class="col-lg-6">
                  <input class="form-control" v-model="credentials[cred[0]]">
                </div>
                <div class="col-lg-3">
                  <button v-tooltip="'Remove this credential'" class="btn btn-danger btn-sm pull-right"
                          @click="removeProp(cred[0])"><i class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-t-sm">
            <label>Add New Credentials</label>
            <div v-for="(cred, i) in newCredentials" :key="i + '-' + account.name"
                 :class="'col-lg-12 ' + ((i === newCredentials.length - 1) ? 'green-left-border' : '')">
              <div class="row m-t-xs">
                <div class="col-lg-5">
                  <input type="text" placeholder="email, username etc..." class="form-control" v-model="cred.prop"
                         :ref="'propInput-' + i">
                </div>
                <div class="col-lg-5">
                  <input type="text" placeholder="value" class="form-control" v-model="cred.val"
                         @keydown.enter="addValue">
                </div>
                <div class="col-lg-2 buttons-container">
                  <button v-if="newCredentials.length - 1 === i" class="btn btn-success btn-sm"
                          v-tooltip="'Add new credential to the list'" @click="addValue">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row m-t-sm" :style="'display: flex; justify-content: space-between'">
            <span><strong>Data must be decrypted before edit</strong></span>
            <button class="btn btn-sm btn-success" @click="decryptCredentials()"><i class="fa fa-key m-r-xs"></i>Decrypt
            </button>
          </div>
        </div>
      </div>
      <div slot="footer" v-if="isDecrypted">
        <button class="btn btn-success pull-rigth" @click="addCredentials"><i class="fa fa-edit"></i> Save</button>
      </div>
    </a-modal>
    <a-modal modal-id="add-notes">
      <div slot="title">Add a Note</div>
      <div slot="form">
        <div class="row m-t-sm">
          <label>Message</label>
          <textarea class="form-control" cols="30" rows="5" v-model="noteMessage"></textarea>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-primary pull-rigth" :disabled="!noteMessage.length" @click="addNote"><i
          class="fa fa-edit m-r-xs"></i> Save
        </button>
      </div>
    </a-modal>
    <in-wrapper>
      <in-ibox>
        <div slot="content" class="row m-t-sm">
          <div class="col-lg-12">
            <div class="col-lg-4 col-md-12">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th colspan="3">
                    Credentials
                    <button class="btn btn-xs pull-right btn-success" data-toggle="modal" data-target="#add-credentials" @click="initNewCred">Edit
                    </button>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!isDecrypted" class="m-t-xs">
                  <td>
                    <span><strong>Credentials are encrypted</strong></span>
                    <button class="btn btn-success btn-xs pull-right" @click="decryptCredentials"><i
                      class="fa fa-eye"></i> View
                    </button>
                  </td>
                </tr>
                <div v-else-if="isDecrypting" class="loader m-t-xs"></div>
                <tr v-else v-for="(cred, i) in Object.entries(credentials)" :key="account.name + '-' + i">
                  <td><strong>{{ cred[0] }}</strong></td>
                  <td>
                    <span>
                      {{ cred[1] }}
                      <a v-tooltip="'Copy value'" class="pull-right" @click="copyToClipboard(cred[1], true)"><i class="fa fa-copy"></i></a>
                      <a v-if="cred[0] === 'otp'" v-tooltip="'Generate new OTP'" class="pull-right" @click="generateNewOTP"><i class="fa fa-refresh m-r-xs"></i></a>
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-4 col-md-12">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th>
                    Notes
                  </th>
                  <th>
                    <button class="btn btn-xs pull-right btn-primary" data-toggle="modal" data-target="#add-notes"><i
                      class="fa fa-plus"></i> Add
                    </button>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="note in notes" :key="note.id">
                  <td colspan="2">
                    <div class="col-lg-12">
                      <strong>{{ note.author.name }}</strong> @ <small>{{ note.time | aTime('DD.MM.Y HH:mm') }}</small>
                    </div>
                    <div class="col-lg-12">{{ note.message }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-4 col-md-12" v-if="user.admin">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th colspan="2">Views</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="view in viewLogs" :key="view.id">
                  <td>{{ view.message }}</td>
                  <td>{{ view.time | aTime('DD.MM.Y HH:mm') }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </in-ibox>
    </in-wrapper>
  </div>
</template>
<script>
import axios from 'axios'
import { Browser } from '../../../../mixins/helperMixin'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      newCredentials: [{prop: '', val: ''}],
      credentials: {},
      isDecrypted: false,
      isDecrypting: false,
      viewLogs: [],
      notes: [],
      noteMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  props: {
    account: { required: true }
  },
  mixins: [Browser],
  mounted () {
    this.getLogs()
    this.getNotes()
  },
  methods: {
    initNewCred () {
      this.newCredentials = [{prop: '', val: ''}]
    },
    async decryptCredentials () {
      let r = await axios.get(`/v2/service-accounts/${this.$route.params.id}/decrypt`)
      this.isDecrypted = true
      this.credentials = r.data
      this.getLogs()
    },
    async getLogs () {
      let r = await axios.get(`/v2/messages?type=view&targets[type]=accounts&targets[id]=${this.$route.params.id}&orderBy[time]=-1`)
      this.viewLogs = r.data
    },
    async getNotes () {
      let r = await axios.get(`/v2/messages?type=note&targets[type]=accounts&targets[id]=${this.$route.params.id}`)
      this.notes = r.data
    },
    addValue () {
      const {prop, val} = this.newCredentials[this.newCredentials.length - 1]
      if (!prop.trim().length || !val.trim().length) {
        this.$toastr.warning('Please fill the current credential value before adding a new one!')
        return
      }
      if (Object.keys(this.credentials).includes(prop)) {
        this.$toastr.warning('Please enter a different name', 'Same property cannot be entered twice')
        return
      }
      this.initNewCred()
      this.credentials[prop] = val
      this.focusOnNextPropInput()
    },
    focusOnNextPropInput () {
      this.$nextTick(() => {
        let inputRef = 'propInput-' + (this.newCredentials.length - 1)
        this.$refs[inputRef][0].focus()
      })
    },
    async addCredentials () {
      try {
        await axios.patch(`/v2/service-accounts/${this.account.id}`, {credentials: this.credentials})
        this.isDecrypted = false
        this.$toastr.success('Updated crendentials successfully', 'Success!')
        $('#add-credentials').modal('hide')
      } catch (error) {
        this.$toastr.error('Update Failed', error)
      }
    },
    removeProp (prop) {
      if (Object.keys(this.credentials).length === 1) {
        this.$toastr.warning('Credentials cannot be empty. Add another value first if you want to delete this one')
        return
      }
      this.$delete(this.credentials, prop)
    },
    async addNote () {
      try {
        let data = {
          type: 'note',
          message: this.noteMessage,
          targets: [
            {
              type: 'accounts',
              id: this.$route.params.id
            }
          ]
        }
        await axios.post('/v2/messages', data)
        await this.getNotes()
        this.$toastr.success('Note added', 'Success!')
        $('#add-notes').modal('hide')
      } catch (error) {
        this.$toastr.error('Failed to create new note', error)
      }
    },
    async generateNewOTP () {
      try {
        this.isDecrypted = false
        this.isDecrypting = true

        let r = await axios.post(`/v2/service-accounts/${this.$route.params.id}/otp/generate`)
        this.credentials['otp'] = r.data.otp

        this.isDecrypting = false
        this.isDecrypted = true
      } catch (error) {
        this.$toastr.error('Failed to generate new OTP', error)
      }
    }
  }
}
</script>
<style scoped>
.green-left-border {
  border-left: 5px solid #18a689;
}
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ServiceAccounts/SingleView/Content.vue